import type { AgentInfo } from '../../agents-api.ts';
import { icon } from '../../icons.ts';
import { ago, h } from '../../ui.ts';
import { branchLabel, lastActivity, previewChip, questionBox, statusBadge } from './parts.ts';

/**
 * One agent in a list, like Claude Code's agent list: status, title, project and branch, the last thing it did, its
 * preview, and its question with an answer field right there. The title link covers the row.
 */
export function agentRow(a: AgentInfo, opts: { project?: boolean; onChange?: (a: AgentInfo) => void } = {}) {
  const row = h(
    'article',
    { class: `agent-row ${a.status}`, 'data-id': a.id, 'data-v': String(a.updatedAt) },
    h(
      'div',
      { class: 'agent-row-main' },
      statusBadge(a.status),
      h(
        'div',
        { class: 'agent-row-body' },
        h('a', { class: 'agent-row-title stretch', href: `#/agent/${encodeURIComponent(a.id)}` }, a.title || a.task),
        h(
          'div',
          { class: 'agent-row-meta' },
          opts.project === false ? null : h('span', {}, a.project),
          branchLabel(a.branch),
        ),
        h('div', { class: 'agent-row-activity' }, lastActivity(a)),
      ),
      h(
        'div',
        { class: 'agent-row-side' },
        previewChip(a),
        h('time', { class: 'muted mono', datetime: new Date(a.updatedAt).toISOString() }, ago(a.updatedAt)),
        h('span', { class: 'chev' }, icon.right()),
      ),
    ),
  );
  if (a.question) row.append(questionBox(a, (next) => opts.onChange?.(next), true));
  return row;
}

/** Leave a row alone while the owner is typing an answer in it. */
export const isEditing = (row: Element) =>
  row.contains(document.activeElement) ||
  [...row.querySelectorAll('input')].some((i) => (i as HTMLInputElement).value.trim() !== '');
